
import { portfolioData } from '../../../mocks/portfolio';

export default function About() {
  return null;
}